import React, { useCallback, useState } from "react";
import { marked } from 'marked';
import { Modal, useModal } from "./Modal";
import { makeCdnUrl } from 'motion-master-client';


const UiChangelog = () => {
  const { isOpen, open, close } = useModal();
  const [changelog, setChangelog] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const changelogUrl = makeCdnUrl('/oblac-drives-changelog.md');

  const handleModalOpen = () => {
    fetchChangelog();
    open();
  };

  const fetchChangelog = useCallback(() => {
    if (isFetching) return;

    setIsFetching(true);

    fetch(changelogUrl)
      .then((res) => {
        if (res.ok) return res.text();
        throw new Error(res.statusText);
      })
      .then((md) => {
        setFetchError(null);
        setChangelog(marked.parse(md ?? ""));
      })
      .catch((res) => {
        console.error(res);
        setFetchError(res);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [changelogUrl, isFetching]);

  return (
    <>
      <button type="button" onClick={handleModalOpen} className="dropdown-item">
        View OBLAC Drives UI Changelog
      </button>
      <Modal title="OBLAC Drives UI" isOpen={isOpen} size="lg" isScrollable={true} onClose={close}>
        {isFetching && !fetchError && <strong role="status">Loading...</strong>}
        {changelog && <div dangerouslySetInnerHTML={{ __html: changelog }}></div>}
        {fetchError && <strong className="text-danger">{fetchError.message}</strong>}
      </Modal>
    </>
  );
};

export default UiChangelog;
